import useTranslation from '@/hooks/use-translation';

export type Testimonial = {
  title: string;
  author: string;
  platform: string;
  date: string;
  text: string;
  url: string;
};

const useReviewOptions: (testimonials?: Array<Testimonial>) => Testimonial[] = (
  testimonials?: Array<Testimonial>,
) => {
  const { t } = useTranslation('pages.welcome-page.reviews.testimonials');

  return Array(3)
    .fill(0)
    .map((_, index) => ({
      title:
        testimonials?.[index]?.title || t(`testimonial-${index + 1}.title`),
      author:
        testimonials?.[index]?.author || t(`testimonial-${index + 1}.author`),
      platform:
        testimonials?.[index]?.platform ||
        t(`testimonial-${index + 1}.platform`),
      date: testimonials?.[index]?.date || t(`testimonial-${index + 1}.date`),
      text: testimonials?.[index]?.text || t(`testimonial-${index + 1}.text`),
      url: testimonials?.[index]?.url || t(`testimonial-${index + 1}.url`),
    }));
};

export default useReviewOptions;
